import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { useDeploymentPreviewOperations } from '../hooks/useDeploymentPreviewOperations';
import { DeploymentPreview } from '../types';
import { DeploymentPreviewDisclosure } from './DeploymentPreviewDisclosure';
import { DeploymentPreviewTable } from './DeploymentPreviewTable';
import { useDeploymentPreviewContext } from './context/useDeploymentPreviewContext';

interface Props {
  ids: string[];
  setCleanUpPreviews?: Dispatch<SetStateAction<DeploymentPreview[]>>;
}

export const CleanUpDisclosure: FC<Props> = ({ ids, setCleanUpPreviews }) => {
  const [expanded, setExpanded] = useState<boolean>(false);
  const { fetchPreviewOperations, previewOperations } =
    useDeploymentPreviewOperations(ids);
  const { isAdvanced } = useDeploymentPreviewContext();

  useEffect(() => {
    if (expanded) fetchPreviewOperations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expanded]);

  if (ids.length === 0) return <></>;

  return (
    <DeploymentPreviewDisclosure
      expanded={expanded}
      setExpanded={setExpanded}
      label={`A previous failed or aborted provisioning operation left ${ids.length} components in a corrupt status.`}
      bold="They will be undeployed."
    >
      <DeploymentPreviewTable
        rows={previewOperations.value || []}
        loading={previewOperations.loading}
        enableCleanUpMultiSelection={isAdvanced}
        setCleanUpPreviews={setCleanUpPreviews}
      />
    </DeploymentPreviewDisclosure>
  );
};
